<template>
  <div>
    <b-toast
      v-for="t in toasts"
      :id="`${t.toastId}`"
      :key="`toast_${t.toastId}`"
      :title="t.title"
      :toaster="t.position"
      :variant="t.variant"
      :solid="true"
      no-auto-hide
    >
      {{ t.msg }}
    </b-toast>
  </div>
</template>

<script>
import { toasterMethods, toasterGetters } from '@state/helpers'
export default {
  data() {
    return {
      toasts: [],
    }
  },
  computed: {
    ...toasterGetters,
  },
  watch: {
    getToast(val) {
      if (val && !val.hide) {
        this.toasts.splice(0, 0, val)
        setTimeout(() => {
          this.$bvToast.show(val.toastId)
          setTimeout(() => {
            this.$bvToast.hide(val.toastId) // hide the UI

            setTimeout(() => {
              let idx = this.toasts.findIndex((t) => t.toastId === val.toastId)
              if (idx > -1) {
                this.toasts.splice(idx, 1)
              }
            }, 300) // wait sometime for UI to hide, then remove from array - smooth UI
          }, val.timeout)
        }, 200) // this timeout is for waiting the UI to render the b-toast component
      }
    },
  },
  methods: {
    ...toasterMethods,
  },
}
</script>
<style lang="scss" scoped>
.b-toast:nth-child(1) {
  padding-top: 65px;
}
</style>
